module.exports = __webpack_public_path__ + "img/zoomCrop-256--tiny4.7f252aad.png";